<div class="pnl pnl-config">
    <header>
        <strong>Prepare-se para começar a vender online</strong>
        Siga esses primeiros passos essenciais
    </header>
    <section>
        <nav>
            <a class="active">Senha de acesso</a>
            <a>Adicionar logotipo</a>
            <a>Adicionar domínio</a>
            <a>Adicionar produto</a>
        </nav>
        <div class="tab-config">
            <div>
                <div class="cfg-tab-header">
                    <div class="content">
                        <strong>Crie uma senha de acesso</strong>
                        
                        <p>Para maior segurança, crie uma nova senha para substituir a senha automática que enviamos para você ao criar esta loja.</p>
                    </div>
                    <div class="figure">
                        <i class="ic ic-locked"></i>
                    </div>
                </div>
            
                <form class="cfg-tab-form">
                    <div class="row mb20">
                        <label for="cfgSenha" class="form-label">Nova senha</label>
                        <input id="cfgSenha" name="senha" class="form-control">
                    </div>

                    <div class="row mb20">
                        <label for="cfgConfirmSenha" class="form-label">Confirme a nova senha</label>
                        <input id="cfgConfirmSenha" name="confirm_senha" class="form-control">
                    </div>

                    <button class="btn btn-primary btn-salvar" type="submit">Salvar</button>
                </form>
                <strong class="row warning dnone">
                    Sua nova senha foi alterada com sucesso.
                </strong>
            </div>
        </div>
        <div class="tab-config dnone">
            <div>
                <div class="cfg-tab-header">
                    <div class="content">
                        <strong>Personalize a loja com o logotipo</strong>
                        
                        <p>Assim como a fachada da sua loja física tem a marca do supermercado, adicione um logotipo para dar identidade ao site.</p>
                    </div>
                    <div class="figure">
                        <i class="ic ic-diamond"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-config dnone">
            <div>
                <div class="cfg-tab-header">
                    <div class="content">
                        <strong>Adicione um domínio para a sua loja</strong>
                        
                        <p>Se você já possui um domínio, poderá utilizá-lo aqui na sua nova loja. Se preferir, poderá utilizar o nosso subdomínio abaixo:</p>
                    </div>
                    <div class="figure">
                        <i class="ic ic-www"></i>
                    </div>
                </div>

                <div class="cfg-dominio"><b>supermercadonovaprata</b>.superhoje.com</div>

                <form class="cfg-tab-form">
                    <div class="row mb20">
                        <label for="cfgDominio" class="form-label">Já tem um domínio e quer usar? Digite abaixo o endereço</label>
                        <input id="cfgDominio" name="dominio" class="form-control">
                    </div>

                    <button class="btn btn-primary btn-salvar" type="submit">Salvar</button>
                </form>
            </div>
        </div>
        <div class="tab-config dnone">
            <div>
                <div class="cfg-tab-header">
                    <div class="content">
                        <strong>Adicione os preços nos produtos</strong>
                        
                        <p>A nossa plataforma já possui milhares de produtos pré-cadastrados com fotos profissionais. Você só terá que colocar os preços nos produtos. Um ou outro produto precisará ser cadastrado manualmente.</p>
                    </div>
                    <div class="figure">
                        <i class="ic ic-table-price"></i>
                    </div>
                </div>
                <p>Para automatizar este processo de inclusão de preços, se você possuir um arquivo Excel contendo o código EAN do produto, anexe-o abaixo:</p>
                <button class="btn btn-primary-outline btn-import" type="submit">clique aqui para anexar</button>
            </div>
        </div>
    </section>
</div>